module.exports = __webpack_public_path__ + "static/media/Childcare.7eaf4b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/Childcare.png
// module id = 572
// module chunks = 0